import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs uppercase tracking-[0.3em] text-accent-yellow ${className}`}>{children}</p>
);

const base = "group inline-flex items-center justify-center gap-3 text-sm font-semibold transition-colors duration-300 whitespace-nowrap";
const variants = {
  solid: "px-7 py-3.5 rounded-xl bg-accent-yellow text-ink hover:bg-white",
  ghost: "px-7 py-3.5 rounded-xl border border-white/25 font-medium hover:border-accent-yellow hover:text-accent-yellow",
  link: "text-accent-yellow font-medium",
};

export const Btn = ({ to, href, onClick, variant = "solid", children, testid, arrow = true, className = "" }) => {
  const Icon = variant === "link" ? ArrowUpRight : ArrowRight;
  const content = (
    <>
      {variant === "link" ? <span className="line-hover">{children}</span> : children}
      {arrow && (
        <Icon
          size={variant === "link" ? 16 : 18}
          className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-[1px]"
        />
      )}
    </>
  );
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} data-testid={testid} className={cls}>{content}</Link>;
  if (href) return <a href={href} data-testid={testid} className={cls}>{content}</a>;
  return <button onClick={onClick} data-testid={testid} className={cls}>{content}</button>;
};

export const PageHeader = ({ overline, title, lead }) => (
  <header className="pt-28 md:pt-32 pb-12 md:pb-20 max-w-[1440px] mx-auto px-6 md:px-12">
    <Overline className="mb-6">{overline}</Overline>
    <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight leading-[0.95] max-w-4xl">
      {title}
    </h1>
    {lead && <p className="mt-8 max-w-xl text-lg font-light text-white/60 leading-relaxed">{lead}</p>}
  </header>
);
